import { useAuth } from "@/context/auth/useAuth";
import { featuresService } from "@/services/featuresService";
import { useEffect, useState } from "react";

export const useFeature = (feature: string): boolean => {
  const { featuresLoaded } = useAuth();
  // Inicializa lendo o featuresService de forma síncrona: as features já
  // vêm do localStorage no boot, e começar em `false` fazia o primeiro
  // render commitado esconder tudo de quem tem permissão — montando e
  // desmontando a tela errada (request órfã, script de terceiro injetado,
  // aba piscando) antes do efeito corrigir.
  const [hasAccess, setHasAccess] = useState<boolean>(() =>
    featuresService.hasFeature(feature)
  );

  useEffect(() => {
    const result = featuresService.hasFeature(feature);
    setHasAccess(result);
  }, [feature, featuresLoaded]);

  return hasAccess;
};

export const useFeatures = (): string[] => {
  const [features, setFeatures] = useState<string[]>([]);

  useEffect(() => {
    const loadFeatures = () => {
      const result = featuresService.getFeatures();
      setFeatures(result);
    };

    loadFeatures();
  }, []);

  return features;
};
